// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#walletTitle {
    font-family: OpenSans;
    font-weight: 300;
    font-size: 32px;
    color: var(--main-link-color);
    margin-top: 0;
    margin-bottom: 0;
    line-height: 60px;
}

.container__nav__bo {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
}

.container__nav__bo .profilName {
    font-size: 16px;
    text-transform: uppercase;
    text-align: center;
    margin: 0;
    color: var(--footer-selected-color);
    margin-right: 30px;
}

.container__nav__bo svg {
    color: #FF9E17;
}

.nameUsers {
    display: flex;
    align-items: center;
    justify-content: center;
}

.logoApp {
    height: 25px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: auto;
    margin-right: auto;
}

.container__header:nth-child(2) {
    max-width: 60%;
    width: 60%;
}

.container__header {
    max-width: 20%;
    width: 20%;
}

.container__logo div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}


/*mobile*/
@media (max-width: 480px) {
    .nameUsers  {
        display: flex;
        flex-direction: column;
    }
    .container__logo .logoApp {
        height: 14px !important;
        padding-left: 20px;
    }
    .nameUsers {
        justify-content: flex-end;
        align-items: center;
    }


    .container__header:nth-child(2) {
        max-width: 50%;
        width: 50%;
    }

    .container__header {
        max-width: 25%;
        width: 25%;
    }

    #walletTitle {
        font-size: 24px !important;
    }

    .container__nav__bo  .profilName {
        margin-right: 0;
    }

    .container__header .actionLink {
        width: auto;
        padding-top: 0;
    }

    .container__nav__bo .profilName {
        font-size: 14px!important;
    }
}

/*tablette*/
@media (max-width: 970px) and (min-width: 480px) {
    .container__header:nth-child(2) {
        max-width: 33%;
        width: 33%;
    }

    .container__header {
        max-width: 33%;
        width: 33%;
    }

    .container__header .actionLink {
        width: auto;
    }
}

`, "",{"version":3,"sources":["webpack://./src/App/css/header.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;;AAGA,SAAS;AACT;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;IACA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;;IAGA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,WAAW;AACX;IACI;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["#walletTitle {\n    font-family: OpenSans;\n    font-weight: 300;\n    font-size: 32px;\n    color: var(--main-link-color);\n    margin-top: 0;\n    margin-bottom: 0;\n    line-height: 60px;\n}\n\n.container__nav__bo {\n    display: flex;\n    justify-content: space-between;\n    background: #ffffff;\n}\n\n.container__nav__bo .profilName {\n    font-size: 16px;\n    text-transform: uppercase;\n    text-align: center;\n    margin: 0;\n    color: var(--footer-selected-color);\n    margin-right: 30px;\n}\n\n.container__nav__bo svg {\n    color: #FF9E17;\n}\n\n.nameUsers {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.logoApp {\n    height: 25px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.container__header:nth-child(2) {\n    max-width: 60%;\n    width: 60%;\n}\n\n.container__header {\n    max-width: 20%;\n    width: 20%;\n}\n\n.container__logo div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n\n/*mobile*/\n@media (max-width: 480px) {\n    .nameUsers  {\n        display: flex;\n        flex-direction: column;\n    }\n    .container__logo .logoApp {\n        height: 14px !important;\n        padding-left: 20px;\n    }\n    .nameUsers {\n        justify-content: flex-end;\n        align-items: center;\n    }\n\n\n    .container__header:nth-child(2) {\n        max-width: 50%;\n        width: 50%;\n    }\n\n    .container__header {\n        max-width: 25%;\n        width: 25%;\n    }\n\n    #walletTitle {\n        font-size: 24px !important;\n    }\n\n    .container__nav__bo  .profilName {\n        margin-right: 0;\n    }\n\n    .container__header .actionLink {\n        width: auto;\n        padding-top: 0;\n    }\n\n    .container__nav__bo .profilName {\n        font-size: 14px!important;\n    }\n}\n\n/*tablette*/\n@media (max-width: 970px) and (min-width: 480px) {\n    .container__header:nth-child(2) {\n        max-width: 33%;\n        width: 33%;\n    }\n\n    .container__header {\n        max-width: 33%;\n        width: 33%;\n    }\n\n    .container__header .actionLink {\n        width: auto;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
